
export default  {
    bindings: {
      page: '='
    },
    controller: 'pageContentGenericController',
    template: require('../views/pageContent.heroText.html')
  };
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.heroText.component.js